import React from "react";
import { HashRouter as Router, Route, Routes, Link } from "react-router-dom";
import Home from "./components/Home";
import Input from "./components/Input";
import InitialView from "./components/InitialView";
import Page2 from "./components/Page2";
import Page3 from "./components/Page3";
import Page4 from "./components/Page4";
import Page5 from "./components/Page5";
import Round from "./components/Round";
import Verify from "./components/Verify";
import Completed from "./components/completed";
import Layout from "./components/layout";

function App() {
  return (
    <Router>
      <div>
        <nav>
          <ul>
            <li>
              <Link to="/"></Link>
            </li>
          </ul>
        </nav>

        <Routes>
          <Route path="/" element={ <Layout> <Home /> </Layout>}/>
          <Route path="/input" element={ <Layout> <Input /> </Layout>} />
          <Route path="/initial" element={ <Layout> <InitialView /> </Layout>} />
          <Route path="/page2" element={ <Layout> <Page2 /> </Layout>} />
          <Route path="/page3" element={<Page3 />} />
          <Route path="/page4" element={<Page4 />} />
          <Route path="/page5" element={<Page5 />} />
          <Route path="/round" element={<Round />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/completed" element={<Completed />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
